import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import DropdownInner from './DropdownInner';
const Dropdown = ({
  buttonTitle,
  dropdownTitles,
  index,
  moveTo,
  forceDropdown,
  isModular,
}) => {
  const [dropdownTopLevel, setDropdownTopLevel] = useState(false);

  useEffect(() => {
    if (forceDropdown) {
      setDropdownTopLevel(true);
    }
  }, [forceDropdown]);
  return (
    <div className="dropdown-subject-container" key={index}>
      {!isModular && (
        <button
          className={`dropdown-subject ${
            dropdownTopLevel ? 'uncollapsed' : 'collapsed'
          }`}
          onClick={() => {
            setDropdownTopLevel(!dropdownTopLevel);
          }}
        >
          {buttonTitle}
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
      )}
      {dropdownTopLevel
        ? dropdownTitles?.map(({ question, answer }, index) => {
            return (
              <DropdownInner
                question={question}
                answer={answer}
                index={index}
                forceDropdown={moveTo === question}
              />
            );
          })
        : null}
    </div>
  );
};

export default Dropdown;
